export default __webpack_public_path__ + "static/media/app.774afb5d.png";